import React, {Component} from 'react';
import {connect} from 'react-redux'
import PropTypes from 'prop-types';
import bindAll from 'lodash.bindall';

import styles from "../css/App.css";

import LoginContainer from './login.jsx'
import AlertComponent from './alert.jsx';
import HomeContainer from './home.jsx';
import ClassdataContainer from './classdata.jsx';
import RankingListContainer from './rankingList.jsx';
import StudentinfoContainer from './studentinfo.jsx';
import ActivityListContainer from './activityList.jsx';
import ActivityDetailContainer from './activityDetail.jsx';
import DongtaiDetailContainer from './dongtaiDetail.jsx';
import VersionUpdateContainer from './versionUpdate.jsx';
import ZipingListContainer from './zipingList.jsx';
import ActivityShenheContainer from './activityShenhe.jsx';
import TermreportContainer from './termreport.jsx';

import {openVersionUpdateModal,openAlert,openActivityDetailModal} from "../redux/actions/modelsActive";

class App extends Component {
    constructor(props) {
        super(props)

        bindAll(this, []
        );
        this.state = {

        }
    }

    componentDidMount() {
        ///this.props.openActivityDetailModal();
        //this.props.openVersionUpdateModal();
        //this.props.openAlert();
    }

    render() {
        const {termreportVisible,activityShenheVisible,activityDetailVisible,dongtaiDetailVisible,manageVisible,versionUpdateVisible, alertVisible, homeVisible,classVisible,rankingListVisible,studentinfoVisible,activityListVisible,zipingListVisible} = this.props;

        return (
            <div >
                {manageVisible ? <LoginContainer/> : null}
                {alertVisible ? <AlertComponent/> : null}
                {homeVisible ? <HomeContainer/> : null}
                {classVisible ? <ClassdataContainer/> :null}
                {rankingListVisible ? <RankingListContainer/> :null}
                {studentinfoVisible ? <StudentinfoContainer/>:null}
                {activityListVisible ? <ActivityListContainer/>:null}
                {activityDetailVisible ?<ActivityDetailContainer/>:null}
                {dongtaiDetailVisible ? <DongtaiDetailContainer/>:null}
                {versionUpdateVisible ? <VersionUpdateContainer/>:null}
                {zipingListVisible ? <ZipingListContainer/> :null}
                {activityShenheVisible?<ActivityShenheContainer/> :null}
                {termreportVisible?<TermreportContainer/>:null}

            </div>

        )
    }
}

App.propTypes = {
    // count: PropTypes.number.isRequired,
}

const mapStateToProps = state => {
    return {
        manageVisible: state.modals.manage,
        alertVisible: state.modals.alert,
        homeVisible: state.modals.home,
        classVisible: state.modals.classdata,
        rankingListVisible: state.modals.rankingList,
        studentinfoVisible: state.modals.studentinfo,
        activityListVisible:state.modals.activityList,
        activityDetailVisible:state.modals.activityDetail,
        dongtaiDetailVisible:state.modals.dongtaiDetail,
        versionUpdateVisible:state.modals.versionUpdate,
        zipingListVisible: state.modals.zipingList,
        activityShenheVisible:state.modals.activityShenhe,
        termreportVisible:state.modals.termreport
    }
}
// Map Redux actions to component props
const mapDispatchToProps = dispatch => {
    return {
        openVersionUpdateModal:() => dispatch(openVersionUpdateModal()),
        openAlert:() => dispatch(openAlert()),
        openActivityDetailModal:() => dispatch(openActivityDetailModal()),
    }
}
// Connect component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App);
